import { render, staticRenderFns } from "./Consultorias2.vue?vue&type=template&id=0c3939e4"
import script from "./Consultorias2.vue?vue&type=script&lang=js"
export * from "./Consultorias2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports